import Piano from './piano';

function init () {
  /* eslint no-console: 0 */
  /* eslint one-var: 0 */

  // Request MIDI access
  if (navigator.requestMIDIAccess) {
    navigator.requestMIDIAccess({
      sysex: false // This defaults to 'false' and we won't be covering sysex in this article.
    }).then(onMIDISuccess, onMIDIFailure);
  } else {
    console.error('No MIDI support in your browser.');
  }

  function onMIDISuccess (midiAccess) {
    const inputs = midiAccess.inputs.values();

    // Loop over all available inputs and listen for any MIDI input
    for (let input = inputs.next(); input && !input.done; input = inputs.next()) {
      // Each time there is a midi message call the onMIDIMessage function
      input.value.onmidimessage = onMIDIMessage;
    }
  }

  function onMIDIFailure (e) {
    // When we get a failed response, run this code
    console.log('No access to MIDI devices or your browser doesn\'t support WebMIDI API. Please use WebMIDIAPIShim ' + e);
  }

  function onMIDIMessage (event) {
    /* eslint no-fallthrough: 0 */
    /* eslint no-bitwise: 0 */
    /* eslint eqeqeq: 0 */
    /* eslint default-case: 0 */
    // Mask off the lower nibble (MIDI channel, which we don't care about)
    switch (event.data[0] & 0xf0) {
    case 0x90:
      if (event.data[2] != 0) {  // If velocity != 0, this is a note-on message
        Piano.startNote(event.data[1]);

        return;
      }
        // If velocity == 0, fall thru: it's a note-off.  MIDI's weird, y'all.
    case 0x80:
      Piano.stopNote(event.data[1]);
    }
  }
}

export default { init };



// WEBPACK FOOTER //
// ./src/components/midi-keyboard.js